// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2q-iE","actions":"GroupTable_actions__2IEiG","deleteModalFooter":"GroupTable_deleteModalFooter__ZOWzd"};